import { useMediaQuery, useTheme } from '@mui/material';
import { SwiperSlide } from 'swiper/react';

// Components
import { CarouselCustom } from '../../../organisms';
import { TextCustom } from '../../../atoms';

// Hooks
import { useGetSeguros } from '../query';

// Utils
import { renderImagen, renderNombre } from '../../../../core/utils';

export function CarrucelSegurosMobil({ handleClick }) {
  const { data, isLoading } = useGetSeguros();
  const whiteLabel = process.env.REACT_APP_WHITE_LABEL;

  const seguros = Array.isArray(data?.data)
    ? data.data.filter(seguro => seguro.activo && seguro.whitelabel === whiteLabel)
    : [];

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const segurosCant = Array.isArray(seguros)
    ? matches
      ? seguros.length > 3
        ? seguros.length === 4
          ? 3
          : Math.round(seguros.length / 2)
        : Number(seguros.length)
      : 3
    : 1;

  return (
    <div
      className={`max-w-[80vw] mx-auto text-center lg:hidden mb-1 lg:mb-12 mt-2 `}
    >
      <CarouselCustom spaceBetween={0} slidesPerView={segurosCant}>
        {!isLoading &&
          seguros.map((seguro, idx) => (
            <SwiperSlide key={idx}>
              <div className="flex flex-col items-center" key={seguro.codigo}>
                <div
                  className="bg-card card-seguros-home flex justify-center items-center px-0 py-0 cursor-pointer hover:scale-105 transition-all duration-300 w-[70px] h-[75px] lg:w-[85px] lg:h-[85px] xl:grid xl:grid-cols-2 xl:w-[300px] xl:h-[125px] xl:px-9 xl:py-5 overflow-hidden"
                  onClick={() => handleClick(seguro.codigo, seguro)}
                >
                  <div className="flex justify-center items-center xl:justify-end xl:items-center w-full h-full">
                    <div className="w-full h-full flex items-center justify-center [&>img]:max-h-9 [&>img]:max-w-full [&>img]:w-auto [&>img]:h-auto [&>img]:object-contain">
                      {renderImagen[seguro.codigo]}
                    </div>
                  </div>
                </div>
                <TextCustom
                  text="Seguro de"
                  className="text-[10px] mt-2 fontPRegular color-primary"
                  component="p"
                  variant="p"
                />
                <TextCustom
                  text={renderNombre(seguro.nombre)}
                  className="fontPSemiBold color-primary text-xs text-center w-[95px] md:w-[110px] md:text-base"
                  component="p"
                  variant="p"
                />
              </div>
            </SwiperSlide>
          ))}
      </CarouselCustom>
    </div>
  );
}
